import React from "react";

export const Logistics = () => {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.22727 0.27832C0.550636 0.27832 0 0.828957 0 1.50559V6.14196C0 6.81859 0.550636 7.36923 1.22727 7.36923H1.42223C1.60206 7.99607 2.18189 8.46014 2.86364 8.46014C3.54538 8.46014 4.12521 7.99607 4.30504 7.36923H6.68182C6.90764 7.36923 7.09091 7.18623 7.09091 6.96014V1.50559C7.09091 0.828957 6.54027 0.27832 5.86364 0.27832H1.22727ZM7.63636 1.36923V6.96014C7.63636 7.78366 8.31284 8.46014 9.13636 8.46014C9.81811 8.46014 10.3979 7.99607 10.5778 7.36923H10.7727C11.4505 7.36923 12 6.81968 12 6.14196V4.40652C12 4.2347 11.9638 4.06475 11.894 3.90794L11.0897 2.09846C10.8928 1.655 10.4533 1.36923 9.9684 1.36923H7.63636ZM8.72727 2.18741H9.9684C10.1301 2.18741 10.2763 2.28249 10.3418 2.43031L10.7903 3.44025C10.8705 3.62052 10.7387 3.82378 10.5415 3.82378H8.72727C8.57673 3.82378 8.45455 3.70159 8.45455 3.55105V2.46014C8.45455 2.30959 8.57673 2.18741 8.72727 2.18741ZM2.86364 6.27832C3.24447 6.27832 3.54545 6.5793 3.54545 6.96014C3.54545 7.34098 3.24447 7.64196 2.86364 7.64196C2.4828 7.64196 2.18182 7.34098 2.18182 6.96014C2.18182 6.5793 2.4828 6.27832 2.86364 6.27832ZM9.13636 6.27832C9.5172 6.27832 9.81818 6.5793 9.81818 6.96014C9.81818 7.34098 9.5172 7.64196 9.13636 7.64196C8.75553 7.64196 8.45455 7.34098 8.45455 6.96014C8.45455 6.5793 8.75553 6.27832 9.13636 6.27832Z"
        fill="url(#paint0_linear_1986_100766)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1986_100766"
          x1="5.44823e-08"
          y1="4.36922"
          x2="12"
          y2="4.36922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFCB57" />
          <stop offset="1" stop-color="#FF7443" />
        </linearGradient>
      </defs>
    </svg>
  );
};
